import LoginPage from './LoginPage';
import LoginPageContainer from './LoginPage.container';

export default LoginPageContainer(LoginPage);
